// extracted by mini-css-extract-plugin
export default {"main":"viewTenant_main__ETr7b","heading":"viewTenant_heading__Hd8Kz","root":"viewTenant_root__uupVM","backdrop":"viewTenant_backdrop__xJQMD","cssRoot":"viewTenant_cssRoot__dPtSN"};